<template>
    <div class="app-container">
        <!-- 工具栏 -->
        <div class="filter-container">
            <el-button size="small" class="filter-item" type="primary" icon="el-icon-plus" disabled >新增</el-button>
            <el-button size="small" class="filter-item" type="danger" disabled>批量删除</el-button>
        </div>

        <!-- table 列表 -->
        <el-table class="grayTableTile" size="small"  v-loading="listLoading" :data="tableData" border  @selection-change="handleSelectionChange" style="width: 100%">
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column label="表名" sortable min-width="120">
                <template slot-scope="scope">
                   <span class="link" @click="openPopup(scope.row)"> {{ scope.row.tableName }} </span> 
                </template>
            </el-table-column>

            <el-table-column label="说明" min-width="150" show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.tableComment }}</template>
            </el-table-column>

            <el-table-column label="创建时间" min-width="100">
                <template slot-scope="scope">{{ scope.row.createTime }}</template>
            </el-table-column>

            <el-table-column label="修改时间" min-width="100">
                <template slot-scope="scope">{{ scope.row.updateTime }}</template>
            </el-table-column>

            <!-- 操作 -->
            <el-table-column label="操作" width="180px" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button size="mini" style="padding: 4px 15px;" type="primary" disabled >编辑</el-button>
                    <el-button size="mini" style="padding: 4px 15px;" type="danger"  disabled>删除</el-button>
                </template>
            </el-table-column>

        </el-table>

        <!-- 表名弹窗 -->
        <table-view ref="table" :tableName="tableName"></table-view>

    </div>
</template>

<script>
import TableView from './components/TableView'
import { ajax_middleTableList } from '@Sys~/api/sys'
export default {
    components: {TableView},
    data() {
        return {
            listLoading: false,
            tableData:[],
            multipleSelection: [], // 已选数据
            tableName: '', // 打开的弹窗表名
        }
    },

    created() {
        this.getList()
    },

    methods: {
        // 获取数据
        getList() {
            this.listLoading = true
            ajax_middleTableList().then(response =>{
                if(response.code == 1) {
                    this.listLoading = false
                    this.tableData = response.data
                } else {
                    this.listLoading = false
                }
            })
        },

        // 全选
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection)
        },

        // 打开弹窗
        openPopup(row) {
            this.tableName = row.tableName
            this.$refs['table'].init()
        }
    }
}
</script>

<style lang="scss" scoped>
    .link{
        color: #646cf5;
        cursor: pointer;
    }
</style>